var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Header',{attrs:{"indexData":_vm.indexData,"userInfo":_vm.userInfo,"keyword":_vm.keyword,"showNav":false}}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"},domProps:{"innerHTML":_vm._s(_vm.goodsList.content)}}),_vm._v(" "),_c('Footer',{attrs:{"indexData":_vm.indexData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-3aa4e4d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/pages/zhuanqu.vue
// module id = null
// module chunks = 